import { render } from "./NomSelection.vue?vue&type=template&id=79317a97&scoped=true"
import script from "./NomSelection.vue?vue&type=script&lang=js"
export * from "./NomSelection.vue?vue&type=script&lang=js"

import "./NomSelection.vue?vue&type=style&index=0&id=79317a97&lang=scss&scoped=true"

import exportComponent from "/builds/common/delivery-front/dev-factory/supplyweb/opticam/packages/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79317a97"]])

export default __exports__